import React from 'react'
import { MDXTag } from '@mdx-js/tag'
import {Split} from 'mdx-deck/layouts';
import {CodeSurfer} from 'mdx-deck-code-surfer';
import {default as baseTheme} from 'mdx-deck/themes';
import no4Image from './images/no4.png';
import iconImage from './images/icon.png';
export const theme = {...baseTheme};
export const meta = {
	title: 'crystal tool formatの話',
	event: {
		name: '言語処理系勉強会 Vol.1',
		url: 'https://connpass.com/event/104863/'
	},
	date: new Date('2018-11-17T00:00:00.000Z')
}

export default [
  ({ components, ...props }) => <MDXTag name="wrapper"  components={components}>



<MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal tool format`}</MDXTag>{`の話`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><img src={iconImage} />
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Twitter: @make_now_just`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`GitHub: @MakeNowJust`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`正規表現好き`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`No.4 Crystal Contributor`}</MDXTag>
<img src={no4Image} /></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`Crystal とは？`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`Ruby っぽい構文`}</MDXTag>{`と`}<MDXTag name="strong" components={components} parentName="p">{`C 言語の速度`}</MDXTag>{`を兼ね備えた
プログラミング言語。`}</MDXTag>
<MDXTag name="p" components={components}>{`LLVM でネイティブコードにコンパイルする。`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`a = 1

while true
  case a
  when Int32  then a = "foo"
  when String then break
  end
end

typeof(a) # => String
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="p" components={components}>{`😎 `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://crystal-lang.org/"}}>{`https://crystal-lang.org/`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal`}</MDXTag>{`コマンド色々`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`crystal run foo.cr`}</MDXTag>{`: コンパイル → 実行`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`crystal build foo.cr`}</MDXTag>{`: コンパイル`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal`}</MDXTag>{`コマンド色々`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`crystal docs`}</MDXTag>{`: ドキュメントジェネレータ`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`crystal play`}</MDXTag>{`: プレイグランド`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`crystal tool format`}</MDXTag>{`: フォーマッター`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="p" components={components}>{`今回は`}<MDXTag name="inlineCode" components={components} parentName="p">{`crystal tool format`}</MDXTag>{`の話`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal tool format`}</MDXTag></MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Crystal 公式のフォーマッター`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`コンパイラのソースコードなどは
これでフォーマットされている`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal tool format`}</MDXTag></MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`インデント・末尾のコンマなどを修正`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`元のコードを`}<MDXTag name="strong" components={components} parentName="li">{`可能な限り`}</MDXTag>{`尊重する`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper" Layout={Split} layoutProps={props} components={components}>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`[{foo: "foo"}, {foo: "bar"},
 {foo: "baz"}]
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`[
  {
    foo: "foo",
  },
  {foo: "bar"},
  {
    foo: "baz",
  },
]
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="strong" components={components} parentName="h2">{`普通`}</MDXTag>{`のフォーマッタの実装方法`}</MDXTag>
<MDXTag name="ol" components={components}>
<MDXTag name="li" components={components} parentName="ol">{`ソースコードを構文解析
(このときに位置情報を付加する)`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`抽象構文木を辿りながら
フォーマットしたソースコードを生成する`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="p" components={components}>{`Crystal のような書き方が複数ある言語で、
構文木に全ての情報を付加するのは大変。
(e.g. メソッド呼び出しの括弧の有無、
文字列リテラルの区切り文字)`}</MDXTag>
<MDXTag name="p" components={components}>{`そうでなくとも前述したことをするには
位置情報を確認することが多くなって煩雑。`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal tool format`}</MDXTag>{`での方法`}</MDXTag>
<MDXTag name="ol" components={components}>
<MDXTag name="li" components={components} parentName="ol">{`ソースコードを構文解析`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`字句解析器をもう一度作る`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`抽象構文木を辿りながら、
字句解析器を動かしつつ、
フォーマットしたソースコードを生成する`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="p" components={components}>{`ちなみに実装は、Crystal のリポジトリの、`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`src/compiler/crystal/tools/formatter.cr`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`にあります。`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="p" components={components}>{`驚きの 1 ファイル 4861 行。`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="e.g. 配列のフォーマット"
  code={require('raw-loader!./examples/format_literal_elements.cr').default}
  lang="ruby"
  showNumbers={true}
  dark={true}
  steps={[
    {notes: 'def format_literal_elements'},
    {lines: [3], notes: '最初の`[`の出力'},
    {
      lines: new Array(28 - 11 + 1)
        .join()
        .split(',')
        .map((x, i) => i + 11),
      notes: '`[`のあとに改行が続けば内側のインデントを2に、そうじゃない場合はそのまま',
    },
    {
      lines: new Array(75 - 29 + 1)
        .join()
        .split(',')
        .map((x, i) => i + 29),
      notes: '各要素をフォーマットしていく',
    },
    {
      lines: new Array(45 - 41 + 1)
        .join()
        .split(',')
        .map((x, i) => i + 41),
      notes: '要素をインデントと共にフォーマットする',
    },
    {
      lines: new Array(74 - 49 + 1)
        .join()
        .split(',')
        .map((x, i) => i + 49),
      notes: '要素のあとに続くはずのコンマについての処理',
    },
  ]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`この方法の問題点`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`ソースコードに合わせて字句解析器を動かすので、
実質的に構文解析器の再実装になる`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`e.g. 字句解析器の`}<MDXTag name="inlineCode" components={components} parentName="li">{`next_token`}</MDXTag>{`を一つ忘れると
結果が大きくずれてよく分からなくなる`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`この方法の問題点`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`なので、とてもバグを作りやすい`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`とてもバグを作りやすい`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`大事なことなので`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="p" components={components}>{`他のフォーマッターの実装について書こうとして力尽きた。`}</MDXTag></MDXTag>
]